import { render, staticRenderFns } from "./xuzhi.vue?vue&type=template&id=b5e45524&"
import script from "./xuzhi.vue?vue&type=script&lang=js&"
export * from "./xuzhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports